import { NegotiationState, OutDebt } from '../generated/graphql';
import { getNegBooleans } from './getNegBooleans';

export const getNegotiationStateLabel = (type: NegotiationState) => {
  switch (type) {
    case NegotiationState.ConfirmedByUser:
    case NegotiationState.Expired: return 'Negociación elegida';
    case NegotiationState.SentToBank: return 'Negociación enviada';
    case NegotiationState.ApprovedByBank: return 'Negociación aprobada';
    case NegotiationState.RejectedByBank: return '';
    default: return 'Negociación:';
  }
};

export const getNegotiationStateLabelWithNegType = (
  outDebt: OutDebt,
) => {
  const {
    isTotalPayment,
    isCondonation,
    isPaymentPromise,
    negState,
    isPartialPaymentPromise,
    isBbva,
    isInstallmentsPlan,
    isACPK,
    isMovistarMoney,
    isRappiPay,
    isScotiabank,
    isRefinance,
    isCatchUp,
    isClaro,
  } = getNegBooleans(outDebt);
  const isMovistarAcpk = isMovistarMoney && isACPK;
  const hasPrePayment = (outDebt.negotiation?.alternative.prePayment || 0) > 0;
  const awaitingApply = (isPartialPaymentPromise || (isScotiabank && isRefinance) || isClaro) ? 'Estado: Pago completo' : 'Estado: en proceso de aplicación';
  switch (negState) {
    case NegotiationState.ConfirmedByUser:
      if (isBbva && isInstallmentsPlan) return 'Estado: Pendiente de pago de otras obligaciones';
      return hasPrePayment || isTotalPayment || isPaymentPromise || isCatchUp ? 'Estado: Pendiente de pago' : awaitingApply;
    case NegotiationState.PrepaymentCompleted: return 'Estado: Pendiente de pago';
    case NegotiationState.SentToBank: return (isTotalPayment || isCatchUp) ? 'Estado: Pago recibido, en proceso de cierre' : awaitingApply;
    case NegotiationState.ApprovedByBank: {
      if (isCondonation && isRappiPay) return 'Estado: Aprobado.';
      return isTotalPayment || isMovistarAcpk ? 'Estado: Paz y salvo, deuda cerrada.' : '';
    }
    default:
    case NegotiationState.Expired:
    case NegotiationState.RejectedByBank: return '';
  }
};
